<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.stock }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.delivery_plan }}
        <v-spacer>
 
        </v-spacer>
        <v-checkbox v-model="isIncludeQuotation" :label="use_language.include_all_orders">
          
        </v-checkbox>
                 <v-btn
        class="mb-2 ml-2"
        color="danger"
        style="color: white"
        @click="getOrderPurchaseStock()"
        outlined
        small
      >
        <v-icon left>mdi-refresh</v-icon>{{ use_language.refresh }}
      </v-btn>

      </v-card-title>
    </v-card>

    <!-- การ์ดสรุปข้อมูลรวม -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.overall_summary }}
        <v-spacer></v-spacer>
        <v-select
          v-model="selectedWarehouseID"
          :items="warehouseList"
          item-text="name"
          item-value="id"
          :label="use_language.select_library"
          dense outlined hide-details
          style="max-width:220px"
          @change="getOrderPurchaseStock()"
        ></v-select>
      </v-card-title>
      <v-card-text>
        <v-simple-table class="elevation-0 packhai-border-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" style="width: 80px"></th>
                <th class="text-center" style="width: 80px">{{ use_language.product_image }}</th>
                <th class="text-left">{{ use_language.name_product }}</th>
                <th class="text-left">{{ use_language.type }}</th>
                <th class="text-left">SKU</th>
                <th class="text-right">{{ use_language.stock_remaining }}</th>
                <th class="text-right">{{ use_language.reserved }}</th>
                <th class="text-right">{{ use_language.incoming_stock }}</th>
                <th class="text-right">{{ use_language.actual_remaining }}</th>
                <th class="text-center">{{ use_language.stock_shortage_start_date }}</th>
              </tr>
            </thead>
            <draggable
              tag="tbody"
              v-model="summaryList"
              handle=".drag-handle"
              @end="onReorder"
            >
              <tr
                v-for="item in summaryList"
                :key="item.productMasterItemID"
              >
                <!-- drag handle + ไปยังรายละเอียด -->
                <td class="text-center" style="width: 80px">
                  <v-icon class="drag-handle" style="cursor: grab">
                    mdi-drag
                  </v-icon>
                  <v-icon
                    color="primary"
                    style="cursor: pointer"
                    :title="use_language.see_details"
                    @click="goToDetail(item)"
                  >
                    mdi-text-box-search-outline
                  </v-icon>
                </td>
                <!-- รูปสินค้า -->
                <td class="text-center" style="width: 80px">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    @click="OpenPhoto(item.photoLink)"
                    class="v-avatar rounded-0 v-avatar--tile"
                  >
                    <img :src="item.photoLink" class="picsize" />
                  </a>
                </td>
                <!-- ชื่อสินค้า, barcode -->
                <td class="text-left" style="min-width: 180px; max-width: 260px">
                  <div style="white-space: normal; word-break: break-word;">{{ item.productName }}</div>
                  <div v-if="item.barcode" style="color: #666;font-size: 12px;">{{ use_language.barcode }}: {{ item.barcode }}</div>
                </td>
                <!-- ลักษณะ -->
                <td class="text-left" style="min-width: 120px">
                  <span v-if="item.productProperty != null && item.productProperty != ''">{{ item.productProperty }}</span>
                  <span v-else>-</span>
                </td>
                <!-- SKU -->
                <td class="text-left" style="min-width: 120px">
                  <span v-if="item.sku">{{ item.sku }}</span>
                  <span v-else>-</span>
                </td>
                <!-- สต๊อกเหลือ -->
                <td
                  class="text-right"
                  style="width: 100px"
                  :class="{ 'text-danger': item.currentStock < 0 }"
                >
                  {{ format_number(item.currentStock) }}
                </td>
                <!-- จอง -->
                <td class="text-right" style="width: 100px">
                  {{ format_number(item.reserved) }}
                </td>
                <!-- สินค้าที่จะเข้า -->
                <td class="text-right" style="width: 110px">
                  {{ format_number(item.incoming) }}
                </td>
                <!-- เหลือจริง -->
                <td
                  class="text-right"
                  style="width: 100px"
                  :class="item.actualLeft >= 0 ? 'text-success' : 'text-danger'"
                >
                  {{ format_number(item.actualLeft) }}
                </td>
                <!-- สินค้าเริ่มขาดวันที่ -->
                <td class="text-center" style="width: 140px">
                  <span v-if="item.deficitDate" class="text-danger">{{ item.deficitDate }}</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </draggable>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- ตาราง -->
    <div>
      
      <v-card
        v-for="item in tabProductList"
        :key="item.productMasterItemID"
        :ref="'detail-' + item.productMasterItemID"
        class="v-card-bottom-30"
        :class="{ 'detail-highlight': highlightedId === item.productMasterItemID }"
      >
        <v-card-text>
       
          <v-row>
            <v-col cols="12">
              <div class="px-0 v-list-item">
                <a
                  v-if="item.photoLink != null && item.photoLink != ''"
                  @click="OpenPhoto(item.photoLink)"
                  class="v-avatar v-list-item__avatar my-0 rounded-0 v-avatar--tile"
                >
                  <img :src="item.photoLink" class="picsize" />
                </a>
                <div class="v-list-item__content">
                  <div>
                    <div class="v-markdown subtitle-1 packhai-showproduct">
                       <div>
                        <div>{{ use_language.name }}</div>
                        <div>: {{ item.productName }}</div>
                      </div>
                       <br />
                      <div>
                        <div>{{ use_language.type }}</div>
                        <div>
                          : {{ item.productProperty != null && item.productProperty != "" ? item.productProperty : null }}
                        </div>
                      </div>
                      <br />
                      <div>
                        <div>{{ use_language.sku }}</div>
                        <div>: {{ item.sku }}</div>
                      </div>
                      <br />
                      <div>
                        <div>{{ use_language.barcode }}</div>
                        <div>: {{ item.barcode }}</div>
                      </div>
                     
                     
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-divider class="py-2" />
          <v-data-table
            :headers="header_product"
            :items="item.itemList"
            :items-per-page="9999999999"
            class="elevation-0 packhai-border-table"
            hide-default-footer
          >
            <!-- หัวตารางซ้อน -->
            <template v-slot:header>
              <thead>
                <tr>
                  <th
                    colspan="1"
                    class="text-center"
                    style="border-bottom: 1px solid #e9edf4"
                  >
                    {{ use_language.date }}
                  </th>
                  <th
                    colspan="3"
                    class="text-center"
                    style="border-bottom: 1px solid #e9edf4"
                  >
                    {{ use_language.order }}
                  </th>
                  <th
                    colspan="2"
                    class="text-center"
                    style="border-bottom: 1px solid #e9edf4"
                  >
                    {{ use_language.purchase }}
                  </th>
                  <th
                    colspan="1"
                    class="text-center"
                    style="border-bottom: 1px solid #e9edf4"
                  >
                    {{ use_language.balance }}
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th class="text-center">{{ use_language.order }}</th>
                  <th class="text-center">{{ use_language.customer }}</th>
                  <th class="text-center">{{ use_language.quantity }}</th>
                  <th class="text-center">{{ use_language.bill }}</th>
                  <th class="text-center">{{ use_language.quantity }}</th>
                  <th></th>
                </tr>
              </thead>
            </template>

            <!-- แถวข้อมูล -->
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center" style="width: 120px"> 
                  <div  >
                    {{  item.dateString  }}
                  </div>
                </td>
                <td class="text-center" style="width: 100px">
                   
                   <a  v-if="item.orderMasterID" @click="order_detail_page(item.orderMasterID)">  {{  item.orderIDText  }} </a>
   
                  <span v-else>{{item.orderIDText }} </span>
                  <span v-if="item.subOrderIDText" style="color: #b3b3b3;font-size: 12px;"><br>  ({{ item.subOrderIDText }})</span>
                </td>
                <td class="text-left" style="width: 200px">
                  {{ item.customerName }}
                </td>
                <td class="text-right" style="width: 100px"> 
                     <span v-if="item.quantityPurchase"> {{ format_number(item.quantityPurchase) }}</span>
                </td>
                <td class="text-center" style="width: 100px">
                  <a  v-if="item.importExportMasterID" @click="purchase_detail_page(item.importExportMasterID)">  {{  item.importOrder  }} </a>
                 
                     <span v-else>{{item.importOrder }}</span>
                </td>
                <td class="text-right" style="width: 100px">
                  <span v-if="item.quantityImport"> {{ format_number(item.quantityImport) }}</span>
                 
                </td>
                <td
                  class="text-right"
                  style="width: 100px"
                  :class="item.quantityLeft >= 0 ? 'text-success' : 'text-danger'"
                >
               {{ format_number(item.quantityLeft )}}
                  
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>

    <!-- แสดงภาพ -->
    <v-dialog v-model="showPhoto" max-width="500">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="showPhotoLink" width="300" />
              <img class="hidden-sm-and-down" :src="showPhotoLink" width="450"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text color="#1976d2" @click="Opentap(showPhotoLink)">{{use_language.newtab}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="showPhoto = false">{{use_language.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/website/components/Loading";
import axios from "axios";
import Swal from "sweetalert2";
import draggable from "vuedraggable";
import { orderService_dotnet } from '@/website/global'
import { format_number, format_order_id, formatDate_thai, format_purchase_id, get_languages } from '@/website/global_function'
import { stockService_dotnet, shopService_dotnet } from "../../global";
// สำหรับ datatable move columns start

// สำหรับ datatable move columns  end

export default {
  components: {
    Loading,
    draggable,
  },
  data: () => ({
    header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
    shop_id: localStorage.getItem('shop_id'),
    staff_id: localStorage.getItem('staff_id'),
    highlightedId: null,
    page_loading: true,
    loading: false,
    use_language: null,
    set_language: null,
    isIncludeQuotation:false,
    selectedWarehouseID: null,
    warehouseList: [],
    //
    tab: null,
    allProductList: [],
    tabProductList: [],
    summaryList: [],
    header_product: [],
    showPhoto: false,
    showPhotoLink: '',
  }),

  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    await this.getWarehouseList()
    await this.getOrderPurchaseStock()
    this.page_loading = false
  },

  methods: {
    format_number, format_order_id, formatDate_thai, format_purchase_id, get_languages,
    async getWarehouseList() {
      try {
        let res = await axios.post(shopService_dotnet + 'Shop/get-warehouse-list',
          { shopID: parseInt(this.shop_id) }, { headers: this.header_token });
        let list = (res.data || []).map(w => ({ id: w.id, name: w.name }));
        this.warehouseList = [{ id: null, name: this.use_language.all_warehouses }, ...list];
      } catch (e) { this.warehouseList = [{ id: null, name: this.use_language.all_warehouses }]; }
    },
    async getOrderPurchaseStock() {
      this.loading = true;
      let response = await axios.post(
        orderService_dotnet + "PO/get-order-purchase-quantity",
        { shopID: this.shop_id,
          isNeedQuotation:this.isIncludeQuotation,
          warehouseID: this.selectedWarehouseID
         },
        { headers: this.header_token }
      );
      var res = response.data;
      this.tabProductList = res.productList || [];

      // จัดลำดับตามที่บันทึกไว้ แล้วสร้างข้อมูลสรุป
      this.applySortOrder();
      this.buildSummary();

      this.loading = false;
    },

    // เรียง tabProductList ตาม sortOrder ที่บันทึกไว้ (ค่าที่ไม่มี sortOrder ไว้ท้ายตามลำดับเดิม)
    // การ์ดรายละเอียดด้านล่างเรียงตามนี้
    applySortOrder() {
      const withIndex = (this.tabProductList || []).map((p, i) => ({ p, i }));
      withIndex.sort((a, b) => {
        const ao = a.p.sortOrder;
        const bo = b.p.sortOrder;
        const aHas = ao != null;
        const bHas = bo != null;
        if (aHas && bHas) return ao - bo;
        if (aHas) return -1;
        if (bHas) return 1;
        return a.i - b.i; // คงลำดับเดิมจาก API
      });
      this.tabProductList = withIndex.map((x) => x.p);
    },

    // สร้างข้อมูลการ์ดสรุปจาก tabProductList (คงลำดับเดียวกัน)
    buildSummary() {
      this.summaryList = (this.tabProductList || []).map((product) => {
        const list = product.itemList || [];
        let reserved = 0;
        let incoming = 0;
        let deficitDate = null;

        for (const row of list) {
          reserved += Number(row.quantityPurchase) || 0;
          incoming += Number(row.quantityImport) || 0;
          if (deficitDate == null && (Number(row.quantityLeft) || 0) < 0) {
            deficitDate = row.dateString;
          }
        }

        // สต๊อกเหลือปัจจุบัน = ยอดคงเหลือแถวแรก + จองแถวแรก - ที่จะเข้าแถวแรก
        let currentStock = 0;
        if (list.length > 0) {
          const first = list[0];
          currentStock =
            (Number(first.quantityLeft) || 0) +
            (Number(first.quantityPurchase) || 0) -
            (Number(first.quantityImport) || 0);
        }

        // เหลือจริง = สต๊อกเหลือ - จอง + สินค้าที่จะเข้า (เท่ากับยอดคงเหลือแถวสุดท้าย)
        const actualLeft = currentStock - reserved + incoming;

        return {
          productMasterItemID: product.productMasterItemID,
          photoLink: product.photoLink,
          productName: product.productName,
          productProperty: product.productProperty,
          sku: product.sku,
          barcode: product.barcode,
          currentStock,
          reserved,
          incoming,
          actualLeft,
          deficitDate,
        };
      });
    },

    // หลังลากเสร็จ: summaryList ถูกจัดลำดับใหม่แล้ว (v-model) → sync ลำดับกลับ tabProductList
    // (เพื่อให้การ์ดรายละเอียดเรียงตาม) แล้วไล่ sortOrder ใหม่ + บันทึก
    onReorder() {
      const orderMap = {};
      this.summaryList.forEach((row, idx) => {
        orderMap[row.productMasterItemID] = idx;
      });
      const newList = [...(this.tabProductList || [])].sort(
        (a, b) => orderMap[a.productMasterItemID] - orderMap[b.productMasterItemID]
      );
      newList.forEach((p, idx) => {
        p.sortOrder = idx;
      });
      this.tabProductList = newList;
      this.buildSummary();
      this.saveSortOrder();
    },

    // บันทึกลำดับไปที่ server
    async saveSortOrder() {
      try {
        const itemList = (this.tabProductList || []).map((p, idx) => ({
          productMasterItemID: p.productMasterItemID,
          sortOrder: idx,
        }));
        await axios.post(
          stockService_dotnet + "Stock/update-stock-planning-order",
          {
            shopID: this.shop_id,
            staffID: this.staff_id,
            itemList: itemList,
          },
          { headers: this.header_token }
        );
      } catch (error) {
        // ไม่ให้ UI พังหาก backend ยังไม่พร้อม
        console.error("saveSortOrder error:", error);
      }
    },

    // คลิกแถวในการ์ดสรุป → เลื่อนไปการ์ดรายละเอียดของสินค้านั้น + ไฮไลต์สั้น ๆ
    goToDetail(item) {
      const refKey = "detail-" + item.productMasterItemID;
      const target = this.$refs[refKey];
      const el = Array.isArray(target) ? target[0] : target;
      if (el && el.$el) {
        el.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        this.highlightedId = item.productMasterItemID;
        setTimeout(() => {
          if (this.highlightedId === item.productMasterItemID) {
            this.highlightedId = null;
          }
        }, 1500);
      }
    },
    order_detail_page(id) {
      window.open("order-detail?id=" + id, "_blank");
    },
    purchase_detail_page(id) {
      window.open("transfer-list/update?id="+btoa(id), "_blank");
    },
    OpenPhoto(Photo) {
      this.showPhotoLink = Photo;
      this.showPhoto = true;
    },
    Opentap(PhotoLink) {
      window.open(PhotoLink);
    },
  },
};
</script>
<style scoped>
.drag-handle {
  cursor: grab;
}
.detail-highlight {
  box-shadow: 0 0 0 2px #1976d2 inset;
  transition: box-shadow 0.3s ease;
}
</style>
